import { PermissionValues } from '@gripp/shared-logic';
import { alertPaths } from './alertPaths';
import { Alerts } from './components/alerts';
import { AlertsManagement } from './components/alertsManagement';
import { AlertsManagementFilterPage } from './components/alertsManagementFilterPage';
import { AlertsManagementToolbar } from './components/alertsManagementToolbar';

export const alertsRoutes = [
  {
    path: `${alertPaths.management}/filters`,
    element: <AlertsManagementFilterPage />,
    handle: {
      header: {
        titleKey: 'alertsManagement.menu.title',
        icon: 'bell-alert',
      },
      requiredPermission: PermissionValues.globalAdmin,
      toolbar: <AlertsManagementToolbar />,
    },
  },
  {
    path: alertPaths.management,
    element: <AlertsManagement />,
    handle: {
      header: {
        titleKey: 'alertsManagement.menu.title',
        icon: 'bell-alert',
      },
      requiredPermission: PermissionValues.globalAdmin,
      toolbar: <AlertsManagementToolbar />,
    },
  },
  // More specific routes must come first
  {
    path: alertPaths.new,
    element: <Alerts />,
    handle: {
      header: {
        titleKey: 'alerts.newAlert',
        icon: 'bell-alert',
      },
    },
  },
  {
    path: alertPaths.edit,
    element: <Alerts />,
    handle: {
      header: {
        titleKey: 'alerts.editAlert',
        icon: 'bell-alert',
      },
    },
  },
  {
    path: alertPaths.list,
    element: <Alerts />,
    handle: {
      header: {
        titleKey: 'alerts.setAlert',
        icon: 'bell-alert',
      },
    },
  },
];
